import * as React from 'react';
import ZoomableImage from '../ZoomableImage';

export default function ParticleImage({ labeled_image, width, height }) {
    return <ZoomableImage imgSrc={labeled_image} imgHeight={height} imgWidth={width} />
}